'use strict';

var KeyMirror = require('keymirror');

module.exports = {
    ActionTypes: KeyMirror({
        LOAD_ACCOUNT_TYPE_LIST: null,
        SELECT_ACCOUNT_TYPE: null
    }),
    labels: {
        accountType: 'Account type'
    },
    MappingConfigurations: {
        AccountTypes: {
            popular: 'isHidden',
            code: 'id',
            valueMapper: function(key, value) { 
                if (key === 'isHidden'){ 
                    return !value;
                } 
            }
        }
    }
};


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./constants/AccountTypeConstants.js